import React from "react";
import PropTypes from "prop-types";
import { Message as SemanticMessage } from "semantic-ui-react";
import "./Message.scss";

export const Message = ({
  icon,
  title,
  content,
  type = "default",
  ...props
}) => {
  return (
    <SemanticMessage
      className="hireart-ds-message"
      icon={icon}
      header={title}
      content={content}
      error={type === "error"}
      info={type === "info"}
      success={type === "success"}
      warning={type === "warning"}
      {...props}
    >
      {props.children}
    </SemanticMessage>
  );
};

Message.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.any,
  type: PropTypes.oneOf(["info", "warning", "success", "error", "default"]),
};

